import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type PaginatedResponse } from '@/types';
import { type Logo, type Competitor } from './types';

interface LogosState {
  competitors: Competitor[];
  collection: Logo[];
  pagination: Partial<PaginatedResponse<Competitor>>;
  loading: boolean;
  error: string | null;
  teamLogos: {
    A?: string;
    B?: string;
  };
}

const initialState: LogosState = {
  competitors: [],
  pagination: {},
  collection: [],
  loading: false,
  error: null,
  teamLogos: {},
};

export const logosSlice = createSlice({
  name: 'logos',
  initialState,
  reducers: {
    setCompetitors: (state, action: PayloadAction<Competitor[]>) => {
      state.competitors = action.payload;
    },
    setCompetitorsPagination: (
      state,
      action: PayloadAction<Partial<PaginatedResponse<Competitor>>>,
    ) => {
      state.pagination = action.payload;
    },
    setCollection: (state, action: PayloadAction<Logo[]>) => {
      state.collection = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTeamLogo: (
      state,
      action: PayloadAction<{ teamType: 'A' | 'B'; logoUrl: string }>,
    ) => {
      state.teamLogos[action.payload.teamType] = action.payload.logoUrl;
    },
    clearTeamLogos: (state) => {
      state.teamLogos = {};
    },
  },
});

export const { reducer: logosReducer } = logosSlice;
